import gql from 'graphql-tag';

export default gql`
  mutation createAutolist(
    $name: String!
    $bookshopId: ID!
    $libraryIds: [ID!]
    $sources: [AutomatedSuggestionsListSourceInput!]!
    $createCart: Boolean
  ) {
    createAutomatedSuggestionsList(
      input: {
        name: $name
        bookshopId: $bookshopId
        submit: true
        libraryIds: $libraryIds
        sources: $sources
        createCart: $createCart
      }
    )
  }
`;
